<template>
  <div class="wp-body" style="padding-bottom:30px;" v-if="!loading" v-loading.fullscreen.lock="loading"
    :element-loading-text="$t('connecting')" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <header class="wp-header">
      <div class="flex flex-wrap gap-2 flex-1">
        <div  v-if="['admin', 'ministry', 'supervisor'].includes(me.role.name)" class="w-full sm:w-52">
          <el-select :placeholder="$t('region')" class="w-full" v-model="region"  @change="regionChanged(); __GET();" clearable>
            <el-option v-for="item in regions" :key="item.id" :label="item[`name_${$i18n.locale}`]?item[`name_${$i18n.locale}`]:item.name_cyr" :value="item.shared_id">
            </el-option>
          </el-select>
        </div>
        <div v-if="['admin', 'ministry', 'supervisor'].includes(me.role.name)" class="w-full sm:w-52">
          <el-select :placeholder="$t('district')" class="w-full"  v-model="district" @change="ChangeDistrict(), __GET()" :disabled="!region" clearable>
            <el-option v-for="item in districts" :key="item.id" :label="item[`name_${$i18n.locale}`]? item[`name_${$i18n.locale}`]:item.name_cyr" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div v-if="['admin', 'ministry', 'supervisor'].includes(me.role.name)" class="w-full sm:w-52">
          <el-select :placeholder="$t('building_category')" class="w-full"  @change="__GET()" v-model="buildinggroup" clearable>
            <el-option v-for="item in building_group" :key="item.id" :label="item[`name_${$i18n.locale}`]?item[`name_${$i18n.locale}`]:item.name_cyr" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="w-full sm:w-52">
          <el-input class="w-full"  :placeholder="$t('search')" prefix-icon="el-icon-search" v-model="search" @keyup.enter.native="__GET()" clearable>
            </el-input>
        </div>
        <div class=" flex items-center gap-2">
          <button class="secondary-btn" @click="fetchOptions()"><h-filter-07 class="icon"/> {{ $t('advanced_filter') }}</button>
          <!-- <button v-if="['admin'].includes(role)"  type="button" class="button dark-blue" :disabled="loading_generate" @click="generate_building_list()">
              <i class="el-icon-download" v-if="!loading_generate"></i>
              <i class="el-icon-loading" v-else></i>
              {{ $t("download") }}
          </button> -->
        </div> 
        <button v-if="multipleSelection.length" class="secondary-btn ml-auto" @click="openChangeStatusDialog">Статусни ўзгартириш</button>
      </div>  
    </header>
    <el-table :data="buildsList" class="" style="width: 99%; margin-bottom: 20px" row-key="id"
      default-expand-all :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column label="№" width="90px" align="center">
        <template slot-scope="scope">
          {{ (current_page - 1) * item_count + (scope.$index + 1) }}
        </template>
      </el-table-column>
      <el-table-column prop="cadastral_number" :label="$t('cadaster_number')" width="220"  sortable>
        <template slot-scope="scope">
          <p class="rounded-lg py-1 px-3 bg-indigo-50 font-bold text-indigo-800 leading-snug w-max cursor-pointer" @click="routeTo(scope.row, 0)">{{
            scope.row.cadastral_number }}</p>
        </template>
      </el-table-column>
      <el-table-column :label="$t('building_name')"  width="250" sortable min-width="250">
        <template slot-scope="scope">
          <button @click="routeTo(scope.row, 0)" class="text-left">
            {{ scope.row.name_cyr ? scope.row.name_cyr : "***" }}
          </button>
        </template>
      </el-table-column>
      <el-table-column :label="$t('building_catagory')" prop="building_group.name_cyr"  sortable min-width="220">
      </el-table-column>
      <el-table-column width="100px" class="p0" prop="finalconclusion" :label="$t('finalconclusion')" 
        sortable>
        <template slot-scope="scope">
          <p class="finalconclusion" :class="`fc__bg-${scope.row.finalconclusion}`">
            {{ scope.row.finalconclusion }}
          </p>
        </template>
      </el-table-column>
      <el-table-column :label="$t('created_at')" width="140" prop="created_at"  sortable>
      </el-table-column>
      <el-table-column :label="$t('year_construction')" width="110" prop="year_construction"  sortable>
      </el-table-column>
      <el-table-column v-if="$route.path !== '/unattested-building-list/new'" :label="$t('investment_project')"
        prop="is_invest"  width="130px">
        <template slot-scope="scope">
          <InvestmentSwitch v-if="scope.row.is_invest" v-model="scope.row.is_invest" :id="scope.row.id" :disabled="role != 'operator'" />
          <p v-else class="bg-indigo-50 py-1 px-3.5 rounded-lg font-semibold text-sm leading-snug w-max">{{ $t('Кирмаган') }}</p>
          
        </template>
      </el-table-column>
      <el-table-column :label="$t('created_by')"  sortable width="190">
        <template slot-scope="scope">
          <div class="table-link-button py-1 px-2.5 flex items-center gap-1 bg-slate-100 hover:bg-slate-200 rounded-md" @click="UserModal(scope.row.created_by)">
            {{
              scope.row.created_by != null &&
                scope.row.created_by.profile != null
                ? scope.row.created_by.profile.name +
                " " +
                scope.row.created_by.profile.surname
                : "-"
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('updated_by')"  sortable min-width="190">
        <template slot-scope="scope">
          <div class="table-link-button py-1 px-2.5 flex items-center gap-1 bg-slate-100 hover:bg-slate-200 rounded-md" @click="UserModal(scope.row.updated_by)">
            {{
              scope.row.updated_by != null &&
                scope.row.updated_by.profile != null
                ? scope.row.updated_by.profile.name +
                " " +
                scope.row.updated_by.profile.surname
                : "-"
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('actions')" width="180" >
        <template slot-scope="scope">
          <div class="flex items-center gap-2">
            <button v-if="role == 'admin'"
              type="button"
              class="w-10 h-10 bg-indigo-50 hover:bg-indigo-100 text-indigo-800 rounded-xl flex items-center justify-center"
              @click="GeneratePasport(scope.row.id)">
              <h-document-text/>
            </button>
            <button @click="DownloadExel(scope.row.id, scope.row.name_cyr)"
              type="button" class="w-10 h-10 bg-slate-100 hover:bg-slate-200 text-indigo-800 rounded-xl flex items-center justify-center">
              <h-file-download/>
            </button>
            <div v-if="
                role !== 'org_admin' &&
                role !== 'admin' &&
                role !== 'ministry_admin' &&
                role !== 'main_org_admin' &&
                !(role == 'operator' && $route.params.type == 'new')
              "
              class="flex items-center gap-2">
              <button @click="routeTo(scope.row, 1)"
                type="button" class="w-10 h-10 bg-slate-100 hover:bg-slate-200 text-indigo-800 rounded-xl flex items-center justify-center">
                <h-eye v-if="role === 'supervisor'"/>
                <h-edit v-else/>
              </button>
              <button v-if="role == 'operator' && false" @click="deleteBuilding(scope.row.id)"
                type="button" class="w-10 h-10 bg-rose-50 hover:bg-rose-200 text-rose-600 rounded-xl flex items-center justify-center">
                <h-trash/>
              </button>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="flex items-center justify-between">
      <div>
        <p class="unnatested-count">
          {{ $t('unattested_count') }}: {{ unattestedCount }}
        </p>
      </div>
      <el-pagination style="margin-left: auto; margin-top: auto" class="ml-auto" :page-sizes="[10, 20, 50, 100]"
        :page-size="5" @current-change="paginate" @size-change="paginateSize" :current-page.sync="current_page1"
        :hide-on-single-page="false" background layout="sizes, prev, pager, next" :page-count="page_count"
        :total="null">
      </el-pagination>
    </div>
    <el-drawer :title="$t('building_passport')" :visible.sync="drawer" direction="rtl">
      <div>
        <div class="pdf">
          <vue-pdf ref="print" :src="pdf"></vue-pdf>
          <div class="loading-pdf" v-show="loadDawer">
            <i class="el-icon-loading"></i>
          </div>
        </div>
        <div class="w-full pdf-control">
          <button class="button add_button" @click="downloadFile(pdf)">
            <i class="el-icon-download mr-2"></i> {{ $t("download") }}
          </button>
          <a :href="pdf" target="_blank">
            <button class="ml-3 button dark-blue">
              <i class="el-icon-view mr-2"></i> {{ $t("see") }}
            </button>
          </a>
        </div>
      </div>
    </el-drawer>
        <div class="modal fs-14" v-if="usermodal">
            <div class="modal-cover"></div>
                <div class="modal-item p-3 sm:p-7 pt-0" style="max-width:664px; ">
                    <div class="flex justify-between items-center py-7">
                        <p class="modal-title text-slate-950" style="margin: 0; font-size: 24px; line-height: 33px; font-weight: 700; ">{{$t('user_date')}}:</p>
                        <button class="bg-slate-100 rounded-xl p-2 text-indigo-900" @click="usermodal=false">
                            <h-remove-circle/>
                        </button>
                    </div>
                    <div class="flex flex-wrap -my-1 sm:-my-2.5 -mx-1">
                        <div class="w-full py-1 sm:py-2.5 px-1">
                            <div class="flex gap-3 items-center bg-slate-50 px-3 py-2 rounded-xl">
                                <div>
                                    <h-user class="w-6 h-6 sm:w-8 sm:h-8 text-cyan-600"/>
                                </div>
                                <div class="flex flex-wrap gap-5">
                                    <div>
                                        <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('last_name')}}</p>
                                        <p class="text-black text-base leading-snug font-bold">{{ userData.profile.surname }}</p>
                                    </div>
                                    <div>
                                        <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('first_name')}}</p>
                                        <p class="text-black text-base leading-snug font-bold">{{ userData.profile.name }}</p>
                                    </div>
                                    <div>
                                        <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('mid_name')}}</p>
                                        <p class="text-black text-base leading-snug font-bold">{{ userData.profile.middlename }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="w-full py-1 sm:py-2.5 px-1">
                            <div class="flex gap-3 items-center bg-slate-50 px-3 py-2 rounded-xl">
                                <div>
                                    <h-home class="w-6 h-6 sm:w-8 sm:h-8 text-cyan-600"/>
                                </div>
                                <div class="flex gap-5">
                                    <div>
                                        <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('organisation_name')}}</p>
                                        <p class="text-black text-base leading-snug font-bold">{{ userData.organization && userData.organization.name_cyr ? userData.organization.name_cyr : '-' }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="w-full sm:w-1/2  py-1 sm:py-2.5 px-1">
                            <div class="flex gap-3 items-center bg-slate-50 px-3 py-2 rounded-xl">
                                <div>
                                    <h-call class="w-6 h-6 sm:w-8 sm:h-8 text-cyan-600"/>
                                </div>
                                <div class="flex gap-5">
                                    <div>
                                        <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('phone_munber')}}</p>
                                        <p class="text-black text-base leading-snug font-bold">{{ userData.profile.phone_number }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="w-full sm:w-1/2  py-1 sm:py-2.5 px-1">
                            <div class="flex gap-3 items-center bg-slate-50 px-3 py-2 rounded-xl">
                                <div>
                                    <h-mail class="w-6 h-6 sm:w-8 sm:h-8 text-cyan-600"/>
                                </div>
                                <div class="flex gap-5">
                                    <div>
                                        <p class="text-slate-400 text-sm leading-snug font-semibold">{{$t('user_email')}}</p>
                                        <p class="text-black text-base leading-snug font-bold">{{ userData.profile.email ? userData.profile.email : '-' }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    <!-- FILTERS -->
    <el-dialog class="advanced-filter-dialog" :show-close="false" :visible.sync="dialogVisible" width="min(1456px, 95%)"
              style="margin-left: 10px;">
              <template slot="title">
                <div class="flex items-center justify-between">
                  <h1 class="text-xl sm:text-2xl font-bold">{{$t('advanced_filter_long')}}</h1>
                  <button class="bg-slate-100 rounded-xl p-2 text-indigo-900" @click="dialogVisible = false">
                    <h-remove-circle/>
                  </button>
                </div>
              </template>
              
              <div class="-mx-4 sm:mx-0 p-4 rounded-2xl bg-cool-50 mb-5">
                <div class="flex items-center gap-2 mb-5">
                  <icon-building-4 class="w-6 h-6 text-cyan-600"/>
                  <h1 class="font-bold text-base sm:text-xl text-slate-950">{{ $t('transport_general_info') }}</h1>
                </div>
                <div class="flex flex-wrap -m-1.5">
                  <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                    <label class="block font-medium text-sm mb-2">
                      {{ $t('cadaster_number') }}
                    </label>
                    <el-input
                      v-model="selectedOptions.cadastral_number"
                      :placeholder="`${$t('example')}: 10:01:01:01:01:1111`"
                      clearable
                    />
                  </div>
                  <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                    <label class="block font-medium text-sm mb-2">
                      {{ $t('name') }}
                    </label>
                    <el-input
                      v-model="selectedOptions[`name_${$i18n.locale}`]"
                      :placeholder="$t('name')"
                      clearable
                    />
                  </div>
                  <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                    <label class="block font-medium text-sm mb-2">
                      {{ $t('year_construction') }}
                    </label>
                    <el-date-picker 
                      v-model="selectedOptions.year_construction"
                      :placeholder="$t('year_of_construction')" 
                      type="year" 
                      value-format="yyyy" 
                      style="width: 100%;"
                      >
                    </el-date-picker>
                  </div>
                  <div class="p-1.5 w-full md:w-1/2 lg:w-1/4">
                    <label class="block font-medium text-sm mb-2">
                      {{ $t('region') }}
                    </label>
                    <el-select 
                      class="w-full" 
                      :placeholder="$t('region')" 
                      v-model="region" 
                      @change="getDistrict(), district = ''"
                      clearable>
                      <el-option v-for="item in regions" :key="item.id"
                        :label="item[`name_${$i18n.locale}`] ? item[`name_${$i18n.locale}`] : item.name_cyr"
                        :value="item.shared_id">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="p-1.5 w-full md:w-1/2 lg:w-1/4">
                    <label class="block font-medium text-sm mb-2">
                      {{ $t('district') }}
                    </label>
                    <el-select 
                      class="w-full" 
                      :placeholder="$t('district')" 
                      v-model="district" 
                      @change="getNeighborhoods()"
                      :disabled="!region" clearable>
                      <el-option v-for="item in districts" :key="item.id" :label="item[`name_${$i18n.locale}`]
                        ? item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="p-1.5 w-full md:w-1/2 lg:w-1/4">
                    <label class="block font-medium text-sm mb-2">
                      {{ $t('neighborhood') }}
                    </label>
                    <el-select 
                      class="w-full" 
                      :placeholder="$t('neighborhood')" 
                      v-model="neighborhood"
                      :disabled="!region" clearable>
                      <el-option v-for="item in neighborhoods" :key="item.id" :label="item[`name_${$i18n.locale}`]
                        ? item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="p-1.5 w-full md:w-1/2 lg:w-1/4">
                    <label class="block font-medium text-sm mb-2">
                      {{ $t('address') }}
                    </label>
                    <el-input
                      v-model="selectedOptions.address"
                      :placeholder="$t('address')"
                      clearable
                    />
                  </div>
                  <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                    <label class="block font-medium text-sm mb-2">
                      {{ $t('floor_count') }}
                    </label>
                    <el-input
                      v-model="selectedOptions.numberfloors"
                      type="number"
                      :placeholder="$t('floor_count')"
                      clearable
                    />
                  </div>
                  <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                    <label class="block font-medium text-sm mb-2">
                      {{ $t('building_category') }}
                    </label>
                    <el-select class="w-full" v-model="buildinggroup" :placeholder="$t('building_category')"
                      clearable>
                      <el-option v-for="item in building_group" :key="item.id" :label="item[`name_${$i18n.locale}`] ?
                        item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
                      </el-option>
                    </el-select>
                  </div>

                </div>
              </div>
              <div class="-mx-4 sm:mx-0 p-4 rounded-2xl bg-cool-50 ">
              <div class="flex items-center gap-2 mb-5">
                  <h-compass class="w-6 h-6 text-cyan-600"/>
                  <h1 class="font-bold text-base sm:text-xl text-slate-950">{{ $t('technical_information') }}</h1>
                </div>
                <div class="bg-white p-4 mb-5" style="border-radius: 20px;">
                  <div class="flex flex-wrap -m-1.5">
                    <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                      <label class="block font-medium text-sm mb-2">
                        {{ $t('transport_seismicity_construction_site') }}
                      </label>
                      <el-select v-model="selectedOptions.buildingseismicity" class="w-full"
                        :placeholder="$t('transport_seismicity_construction_site')" clearable>
                        <el-option v-for="item in options[2]" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                      <label class="block font-medium text-sm mb-2">
                        {{ $t('floors_height') }}
                      </label>
                      <el-input
                        v-model="selectedOptions.floors_height"
                        type="number"
                        :placeholder="$t('floors_height')"
                        clearable
                      />
                    </div>
                    <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                      <label class="block font-medium text-sm mb-2">
                        {{ $t('foundation_type') }}
                      </label>
                      <el-select 
                      class="w-full" 
                      :placeholder="$t('foundation_type')" 
                      v-model="selectedOptions.foundation_type"
                      clearable>
                      <el-option v-for="item in dictionary.foundationtype" :key="item.id" :label="item[`name_${$i18n.locale}`]
                          ? item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                      <label class="block font-medium text-sm mb-2">
                        {{ $t('constructive_solution') }}
                      </label>
                      <el-select v-model="selectedOptions.constructivesolution" class="w-full"
                        :placeholder="$t('constructive_solution')" clearable>
                        <el-option v-for="item in options[0]" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                      <label class="block font-medium text-sm mb-2">
                        {{ $t('part_attic') }}
                      </label>
                      <el-input
                        v-model="selectedOptions.part_attic"
                        type="number"
                        :placeholder="$t('part_attic')"
                        clearable
                      />
                    </div>
                    <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                      <label class="block font-medium text-sm mb-2">
                        {{ $t('loadbearingstatus_input') }}
                      </label>
                      <el-select 
                      class="w-full" 
                      :placeholder="$t('loadbearingstatus_input')" 
                      v-model="selectedOptions.loadbearing"
                      clearable>
                      <el-option v-for="item in dictionary.loadbearing" :key="item.id" :label="item[`name_${$i18n.locale}`]
                          ? item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                      <label class="block font-medium text-sm mb-2">
                        {{ $t('plannedshape') }}
                      </label>
                      <el-select 
                      class="w-full" 
                      :placeholder="$t('plannedshape')" 
                      v-model="selectedOptions.plannedshape"
                      clearable>
                      <el-option v-for="item in dictionary.plannedshape" :key="item.id" :label="item[`name_${$i18n.locale}`]
                          ? item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                      <label class="block font-medium text-sm mb-2">
                        {{ $t('technical_height') }}
                      </label>
                      <el-input
                        v-model="selectedOptions.technical_height"
                        type="number"
                        :placeholder="$t('technical_height')"
                        clearable
                      />
                  </div>
                  <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                    <label class="block font-medium text-sm mb-2">
                      {{ $t('coverings') }}
                    </label>
                    <el-select 
                    class="w-full" 
                    :placeholder="$t('coverings')" 
                    v-model="selectedOptions.coverings"
                    clearable>
                    <el-option v-for="item in dictionary.coverings" :key="item.id" :label="item[`name_${$i18n.locale}`]
                        ? item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                    <label class="block font-medium text-sm mb-2">
                      {{ $t('dimensional_parameters') }}
                    </label>
                    <div class="flex items-center justify-between gap-1.5">
                      <el-input
                      v-model="selectedOptions.length"
                      type="number"
                      :placeholder="$t('transport_length')"
                      clearable
                      />
                      <el-input
                      v-model="selectedOptions.width"
                      type="number"
                      :placeholder="$t('width')"
                      clearable
                      />
                      <el-input
                      v-model="selectedOptions.height"
                      type="number"
                      :placeholder="$t('height')"
                      clearable
                      />
                    </div>
                  </div>
                  <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                    <label class="block font-medium text-sm mb-2">
                      {{ $t('balance_value') }}
                    </label>
                    <el-input
                    v-model="selectedOptions.balance_value"
                    type="number"
                    :placeholder="$t('balance_value')"
                    clearable
                    />
                  </div>
                  <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                    <label class="block font-medium text-sm mb-2">
                      {{ $t('roofsection') }}
                    </label>
                    <el-select 
                    class="w-full" 
                    :placeholder="$t('roofsection')" 
                    v-model="selectedOptions.roofsection"
                    clearable>
                    <el-option v-for="item in dictionary.roofsection" :key="item.id" :label="item[`name_${$i18n.locale}`]
                        ? item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                    <label class="block font-medium text-sm mb-2">
                      {{ $t('divided_into_sections_input') }}
                    </label>
                    <el-select 
                    class="w-full" 
                    :placeholder="$t('divided_into_sections_input')" 
                    v-model="selectedOptions.dividedintosections"
                    clearable>
                    <el-option v-for="item in dictionary.dividedintosections" :key="item.id" :label="item[`name_${$i18n.locale}`]
                        ? item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                    <label class="block font-medium text-sm mb-2">
                      {{ $t('basement_presence') }}
                    </label>
                    <el-select 
                    class="w-full" 
                    :placeholder="$t('basement_presence')" 
                    v-model="selectedOptions.basement_presence"
                    clearable>
                    <el-option v-for="item in dictionary.presence" :key="item.id" :label="item[`name_${$i18n.locale}`]
                        ? item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
                      </el-option>
                    </el-select>
                  </div>

                  </div>
                </div>
                
                <div class="bg-white p-4 mb-5" style="border-radius: 20px;">
                  <div class="flex flex-wrap -m-1.5">
                    <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                      <label class="block font-medium text-sm mb-2">
                        {{ $t('divisions_number') }}
                      </label>
                      <el-input
                        v-model="selectedOptions.divisions_number"
                        type="number"
                        :placeholder="$t('divisions_number')"
                        clearable
                      />
                    </div>
                    <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                      <label class="block font-medium text-sm mb-2">
                        {{ $t('longitudinal_wall') }}
                      </label>
                      <el-input
                        v-model="selectedOptions.longitudinal_wall"
                        type="number"
                        :placeholder="$t('longitudinal_wall')"
                        clearable
                      />
                    </div>
                    <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                      <label class="block font-medium text-sm mb-2">
                        {{ $t('window_betwee_length') }}
                      </label>
                      <el-input
                        v-model="selectedOptions.window_spacing"
                        type="number"
                        :placeholder="$t('window_betwee_length')"
                        clearable
                        />
                    </div>
                    <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                      <label class="block font-medium text-sm mb-2">
                        {{ $t('chok_count') }}
                      </label>
                      <el-input
                        v-model="selectedOptions.section_parameters"
                        type="number"
                        :placeholder="$t('chok_count')"
                        clearable
                        />
                    </div>
                    <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                      <label class="block font-medium text-sm mb-2">
                        {{ $t('longitudinal_wall_spacing') }}
                      </label>
                      <el-input
                        v-model="selectedOptions.longitudinal_wall_spacing"
                        type="number"
                        :placeholder="$t('longitudinal_wall_spacing')"
                        clearable
                        />
                    </div>
                    <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                      <label class="block font-medium text-sm mb-2">
                        {{ $t('walls_length') }}
                      </label>
                      <el-input
                        v-model="selectedOptions.curtains"
                        type="number"
                        :placeholder="$t('walls_length')"
                        clearable
                        />
                    </div>
                    <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                      <label class="block font-medium text-sm mb-2">
                        {{ $t('transverse_wall_step') }}
                      </label>
                      <el-input
                        v-model="selectedOptions.transverse_wall_step"
                        type="number"
                        :placeholder="$t('transverse_wall_step')"
                        clearable
                        />
                    </div>
                  <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                    <label class="block font-medium text-sm mb-2">
                      {{ $t('seismicbelts') }}
                    </label>
                    <el-select 
                    class="w-full" 
                    :placeholder="$t('seismicbelts')" 
                    v-model="selectedOptions.seismicbelts"
                    clearable>
                    <el-option v-for="item in dictionary.beltspresence" :key="item.id" :label="item[`name_${$i18n.locale}`]
                        ? item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                  <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                    <label class="block font-medium text-sm mb-2">
                      {{ $t('connectingbelts') }}
                    </label>
                    <el-select 
                    class="w-full" 
                    :placeholder="$t('connectingbelts')" 
                    v-model="selectedOptions.connectingbelts"
                    clearable>
                    <el-option v-for="item in dictionary.beltspresence" :key="item.id" :label="item[`name_${$i18n.locale}`]
                        ? item[`name_${$i18n.locale}`] : item.name_cyr" :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                    
                  </div>
                </div>
                <div class="bg-white p-4" style="border-radius: 20px;">
                  <div class="flex flex-wrap -m-1.5">
                    <div class="p-1.5 w-1/2 md:w-1/4 lg:w-1/6 flex flex-col justify-center">
                      <label class="block font-medium text-sm mb-2">
                        {{ $t('concrete_class') }}
                      </label>
                      <el-select 
                      class="w-full" 
                      :placeholder="$t('concrete_class')" 
                      v-model="selectedOptions.concrete_class"
                      filterable
                      clearable>
                      <el-option v-for="option in dictionary.concreteclass" :key="option.id" :label="option.name" :value="option.id">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="p-1.5 w-1/2 md:w-1/4 lg:w-1/6 flex flex-col justify-center">
                      <label class="block font-medium text-sm mb-2">
                        {{ $t('brick_brand') }}
                      </label>
                      <el-select 
                      class="w-full" 
                      :placeholder="$t('brick_brand')" 
                      v-model="selectedOptions.brick_brand"
                      clearable>
                      <el-option v-for="option in dictionary.brickbrand" :key="option.id" :label="option.name" :value="option.id">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="p-1.5 w-1/2 md:w-1/4 lg:w-1/6 flex flex-col justify-center">
                      <label class="block font-medium text-sm mb-2">
                        {{ $t('armature_class_armatureclass') }}
                      </label>
                      <el-select 
                      class="w-full" 
                      :placeholder="$t('armature_class_armatureclass')" 
                      v-model="selectedOptions.armature_class"
                      clearable>
                      <el-option v-for="option in dictionary.armatureclass" :key="option.id" :label="option.name" :value="option.id">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="p-1.5 w-1/2 md:w-1/4 lg:w-1/6 flex flex-col justify-center">
                      <label class="block font-medium text-sm mb-2">
                        {{ $t('armature_class_armaturediametr') }}
                      </label>
                      <el-select 
                      class="w-full" 
                      :placeholder="$t('armature_class_armaturediametr')" 
                      v-model="selectedOptions.armaturediametr"
                      clearable>
                      <el-option v-for="option in dictionary.armaturediametr" :key="option.id" :label="option.name" :value="option.id">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                      <label class="block font-medium text-sm mb-2">
                        {{ $t('brick_or_stone_wall_type') }}
                      </label>
                      <el-select 
                      class="w-full" 
                      :placeholder="$t('brick_or_stone_wall_type')" 
                      v-model="selectedOptions.brick_or_stone_wall_type"
                      clearable>
                      <el-option v-for="option in 3" :key="option.id" :label="option" :value="option">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="p-1.5 w-1/2 md:w-1/4 lg:w-1/6 flex flex-col justify-center">
                      <label class="block font-medium text-sm mb-2">
                        {{ $t('mixture_class') }}
                      </label>
                      <el-select 
                      class="w-full" 
                      :placeholder="$t('mixture_class')" 
                      v-model="selectedOptions.mixture_class"
                      clearable>
                      <el-option v-for="option in dictionary.mixtureClasslist" :key="option.id" :label="option.name" :value="option.id">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="p-1.5 w-1/2 md:w-1/4 lg:w-1/6 flex flex-col justify-center">
                      <label class="block font-medium text-sm mb-2">
                        {{ $t('soil_type') }}
                      </label>
                      <el-select 
                      class="w-full" 
                      :placeholder="$t('soil_type')" 
                      v-model="selectedOptions.soil_type"
                      clearable>
                      <el-option v-for="option in dictionary.soiltype" :key="option.id" :label="option.name" :value="option.id">
                        </el-option>
                      </el-select>
                    </div>
                    <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                      <label class="block font-medium text-sm mb-2">
                        {{ $t('steel_resistance') }}
                      </label>
                      <el-input
                        v-model="selectedOptions.steel_resistance"
                        type="number"
                        :placeholder="$t('steel_resistance')"
                        clearable
                      />
                    </div>
                    <div class="p-1.5 w-full md:w-1/2 lg:w-1/3 flex flex-col justify-center">
                      <label class="block font-medium text-sm mb-2">
                        {{ $t('determination_endurance_reserve') }}
                      </label>
                      <el-input
                        v-model="selectedOptions.determination_endurance_reserve"
                        type="number"
                        :placeholder="$t('determination_endurance_reserve')"
                        clearable
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="advanced-filter-btn flex w-full justify-end mt-5">
                <div slot="footer" class="dialog-footer flex justify-end gap-2">
                  <button class="light-button" @click="dialogVisible = false">
                    {{ $t('cancel') }}
                  </button>
                  <button class="primary-button" type="primary" @click="__GET(), dialogVisible = false">
                    {{ $t('search_btn') }}
                    <h-search />
                  </button>
                </div>
              </div>
              
    </el-dialog>
    <el-dialog class="advanced-filter-dialog" :show-close="false" :visible.sync="changeStatusDialogVisible" width="520px">
      <template slot="title">
        <div class="flex items-center justify-between">
          <h1 class="text-xl font-bold">{{ 'Статусни ўзгартириш' }}</h1>
          <button class="bg-slate-100 rounded-xl p-2 text-indigo-900" @click="changeStatusDialogVisible = false">
            <h-remove-circle />
          </button>
        </div>
      </template>
      <div class="p-4 space-y-4">
        <p>{{ 'Танланган бинолар сони' }}: {{ multipleSelection.length }}</p>
        <el-select v-model="selectedStatus" :placeholder="'Статусни танланг'" clearable>
          <el-option v-if="$route.query.status !== 'new'" :label="$t('unattested_new')" value="new"></el-option>
          <el-option :label="$t('approve_btn')" value="approved"></el-option>
          <el-option v-if="$route.query.status !== 'rejected'" :label="$t('reject_btn')" value="rejected"></el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer flex justify-end gap-2">
        <button class="light-button" @click="changeStatusDialogVisible = false">
          {{ $t('cancel') }}
        </button>
        <button
          class="primary-button"
          :disabled="!selectedStatus"
          @click="confirmChangeStatus"
        >
          {{ $t('save')  }}
        </button>
      </div>
    </el-dialog>
  </div>
  <ScletonPage v-else />
</template>

<script>

import ScletonPage from "./../components/Scletons/Page.vue";
import InvestmentSwitch from "@/components/InvestmentSwitch";
import HFilter07 from './Icons/hFilter07.vue';
import HRemoveCircle from './Icons/hRemoveCircle.vue';
import IconBuilding4 from './Icons/iconBuilding4.vue';
import HCompass from './Icons/hCompass.vue';
import HSearch from './Icons/hSearch.vue';
import HFileDownload from './Icons/hFileDownload.vue';
import HLoading from './Icons/hLoading.vue';
import HDocumentText from './Icons/hDocumentText.vue';
import HEdit from './Icons/hEdit.vue';
import HEye from './Icons/hEye.vue';
import HTrash from './Icons/hTrash.vue';
import HUser from '@/components/Icons/hUser.vue';
import HHome from '@/components/Icons/hHome.vue';
import HCall from '@/components/Icons/hCall.vue';
import HMail from '@/components/Icons/hMail.vue';
import Checkbox from '@/components/ui/Checkbox.vue';
export default {
  components: {
    ScletonPage,
    InvestmentSwitch,
    HFilter07,
    HRemoveCircle,
    IconBuilding4,
    HCompass,
    HSearch,
    HFileDownload,
    HLoading,
    HDocumentText,
    HEdit,
        HEye,
    HTrash,
        HUser,
        HHome,
        HCall,
        HMail,
        Checkbox
  },
  data() {
    return {
      multipleSelection: [],
      pdf: "",
      namePdf: "",
      loadDawer: false,
      districts: [],
      drawer: false,
      input2: null,
      page_count: 0,
      buildsList: [],
      region: "",
      district: "",
      neighborhood: "",
      neighborhoods: [],
      buildinggroup: "",
      current_district: [],
      objInfo: {},
      search: "",
      item_count: 10,
      loading: false,
      current_page: 1,
      current_page1: 1,
      buildingtype: "",
      usermodal: false,
      unattestedCount: 0,
      userData: {
        organization: {},
        profile: {},
      },
      loading_generate: false,
      dialogVisible: false,
      changeStatusDialogVisible: false,
      selectedStatus: "",
      rejectReason: "",
      selectedOptions: {},
      placeholders: [
        {
          value: "constructivesolution",
          title: 'constructive_solution',
        },
        {
          value: "plannedshape",
          title: "plannedshape",
        },
        {
          value: "buildingseismicity",
          title: "transport_seismicity_construction_site"
        },
        {
          value: "reconstructiondurability",
          title: "building_reconstruction",
        },
        {
          value: "dailycondition",
          title: "passport_dailycondition",
        },
        {
          value: "dividedintosections",
          title:
            "divided_into_sections_input",
        },
        {
          value: "loadbearing",
          title:
            "loadbearingstatus_input",
        },
        {
          value: "earthquakecondition",
          title:
            "earthquakecondition_input",
        },
        {
          value: "year_construction",
          title: "year_of_construction",
        },
        {
          value: "numberfloors",
          title: "floor_count",
        },
      ],
      options: [],
      dictionary_for_fill: [],
    };
  },
  watch: {
    $route: {
      deep: true,
      handler(val) {
        if (val?.query?.status) {
          this.__GET();
        }
      },
    },
    "$route.params.type"() {
      if (this.$route.params.type == undefined) {
        if (
          this.me.role.name == "ministry" ||
          this.me.role.name == "ministry_admin" ||
          this.me.role.name == "main_org_admin"
        ) {
          this.$router.push("/unattested-building-list/new").catch((e) => {
            if (
              e.name !== "NavigationDuplicated" &&
              !e.message.includes(
                "Avoided redundant navigation to current location"
              )
            ) {
              console.log(e);
            }
          });
        } else {
          if (this.$route.path == "/unattested-building-list/") {
            this.$router.push("/unattested-building-list/exg").catch((e) => {
              if (
                e.name !== "NavigationDuplicated" &&
                !e.message.includes(
                  "Avoided redundant navigation to current location"
                )
              ) {
                console.log(e);
              }
            });
          } else if (this.$route.path == "/unattested-building-list/") {
            this.$router.push("/unattested-building-list/exg").catch((e) => {
              if (
                e.name !== "NavigationDuplicated" &&
                !e.message.includes(
                  "Avoided redundant navigation to current location"
                )
              ) {
                console.log(e);
              }
            });
          }
        }
      } else {
        this.__GET();
      }
    },
  },
  computed: {
    dictionary() {
      return this.$store.state.dictionary;
    },
    baseURL() {
      return axios.defaults.baseURL;
    },
    buildType() {
      let a = {
        exg: "Мавжуд",
        new: "Янги",
      };

      return a[this.$route.params.type];
    },
    me() {
      return this.$store.state.me;
    },
    role() {
      return this.$store.state.role;
    },
    regions() {
      return this.$store.state.dictionary.region;
    },
    building_group() {
      return this.$store.state.dictionary.buildinggroup;
    },
  },
  created() {
    this.loading = true;
    if (this.$route.params.type == undefined) {
      if (
        this.me.role.name == "ministry" ||
        this.me.role.name == "ministry_admin" ||
        this.me.role.name == "main_org_admin"
      ) {
        this.$router.push("/unattested-building-list/new").catch((e) => {
          if (
            e.name !== "NavigationDuplicated" &&
            !e.message.includes(
              "Avoided redundant navigation to current location"
            )
          ) {
            console.log(e);
          }
        });
      } else {
        if (this.$route.path == "/unattested-building-list/") {
          this.$router.push("/unattested-building-list/exg").catch((e) => {
            if (
              e.name !== "NavigationDuplicated" &&
              !e.message.includes(
                "Avoided redundant navigation to current location"
              )
            ) {
              console.log(e);
            }
          });
        } else if (this.$route.path == "/unattested-building-list/") {
          this.$router.push("/unattested-building-list/exg").catch((e) => {
            if (
              e.name !== "NavigationDuplicated" &&
              !e.message.includes(
                "Avoided redundant navigation to current location"
              )
            ) {
              console.log(e);
            }
          });
        }
      }
    } else {
      this.current_page = this.$route.query.page
        ? parseInt(this.$route.query.page)
        : 1;
      this.search = this.$route.query.search ? this.$route.query.search : "";
      this.region = this.$route.query.region
        ? parseInt(this.$route.query.region)
        : "";
      this.district = this.$route.query.district
        ? parseInt(this.$route.query.district)
        : "";
      this.buildinggroup = this.$route.query.buildinggroup
        ? parseInt(this.$route.query.buildinggroup)
        : "";
      this.item_count = this.$route.query.item_count
        ? parseInt(this.$route.query.item_count)
        : 10;
      if (this.region != "") {
        this.getDistrict();
      }
      this.__GET();
    }
  },
  mounted() {

  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val.map((item) => item.id);
    },
    openChangeStatusDialog() {
      this.changeStatusDialogVisible = true;
      this.selectedStatus = "";
      this.rejectReason = "";
    },
    confirmChangeStatus() {
      if (!this.selectedStatus) {
        return;
      }

      this.loading = true;
      axios.patch("/building/specificationlist/bulk-status/", {
        objects: this.multipleSelection,
        status: this.selectedStatus
      })
        .then((res) => {
          if(res.data.status == 'new'){
            this.$notify({
              title: 'Янги статусга ўтказилди',
              type: 'success'
            });
          }else if(res.data.status == 'approved'){
             this.$notify({
              title: this.$t('approve_n'),
              type: 'success'
          })} else if(res.data.status == 'rejected'){
             this.$notify.info({
                    title: this.$t('unattested_rejected_n'),
                });}
          
          this.__GET();
          this.$router.push({ query: { ...this.$route.query, refresh: new Date().getTime() }});
          this.multipleSelection = [];
        })
        .catch((e) => {
          this.$message({
            message: this.$t('status_change_error'),
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false;
          this.changeStatusDialogVisible = false;
        });
    },
    fetchOptions() {
      this.dialogVisible = true

      const data = [
        "constructivesolution",
        "plannedshape",
        "buildingseismicity",
        "reconstructiondurability",
        "dailycondition",
        "dividedintosections",
        "loadbearing",
        "earthquakecondition",
      ]
      data.forEach((option, _) => {
        const arr = []
        this.dictionary[option].forEach(elem => {
          arr.push({
            label: elem.name_cyr || elem.number,
            value: elem.id
          })
        })
        this.options.push(arr)
      })
    },
    GeneratePasport(id) {
      this.loading = true;
      axios
        .post(`/building/specification/${id}/generate/`)
        .then((res) => {
          if (res.data.success) {
            this.drawer = true;
            this.loadDawer = true;
            this.pdf = axios.defaults.baseURL.slice(0, -8) + res.data.pdf_link;
          }
        })
        .catch((e) => { })
        .finally(() => {
          this.loading = false;

          this.loadDawer = false;
        });
    },
    tableRowClassName({ row }) {
      if (row.finalconclusion > 2) {
        return "warning-row";
      }
      if (row.finalconclusion < 3) {
        return "success-row";
      }
    },
    paginate(val) {
      this.current_page = val;
      this.__GET();
    },
    paginateSize(val) {
      this.item_count = val;
      this.__GET();
    },
    __GET() {
      let type = this.$route.params.type.toUpperCase();
      let offset = this.item_count * (this.current_page - 1);
      const status = this.$route.query.status || "new";

      const query = {}

      for (const option in this.selectedOptions) {
        if (this.selectedOptions[option] !== "") {
          query[option] = this.selectedOptions[option]
        }
      }

      if (
        this.search != "" ||
        this.region != "" ||
        this.district != "" ||
        this.buildinggroup != "" ||
        this.item_count != 10
      ) {
        if (this.$route.path == "/unattested-building-list/") {
          const { type } = this.$route.params;
          const {
            current_page,
            region,
            district,
            buildinggroup,
            item_count,
            search,
          } = this;
          this.$router
            .push({
              path: `/unattested-building-list/${type}`,
              query: {
                page: current_page,
                status: status,
                region: region,
                district: district,
                buildinggroup: buildinggroup,
                item_count: item_count,
                search: search,
                ...query
              },
            })
            .catch((e) => {
              if (
                e.name !== "NavigationDuplicated" &&
                !e.message.includes(
                  "Avoided redundant navigation to current location"
                )
              ) {
                console.log(e);
              }
            });
        } else {
          const { type } = this.$route.params;
          const {
            current_page,
            region,
            district,
            buildinggroup,
            item_count,
            search,
          } = this;
          this.$router
            .push({
              path: `/unattested-building-list/${type}`,
              query: {
                page: current_page,
                status,
                region,
                district,
                buildinggroup,
                item_count,
                search,
                ...query
              },
            })
            .catch((e) => {
              if (
                e.name !== "NavigationDuplicated" &&
                !e.message.includes(
                  "Avoided redundant navigation to current location"
                )
              ) {
                console.log(e);
              }
            });
        }
      } else {
        if (
          this.$route.path ==
          `/unattested-building-list/${this.$route.params.type}`
        ) {
          const { type } = this.$route.params;
          const { current_page } = this;
          this.$router
            .push({
              path: `/unattested-building-list/${type}`,
              query: {
                page: current_page,
                status,
                ...query
              },
            })
            .catch((e) => {
              if (
                e.name !== "NavigationDuplicated" &&
                !e.message.includes(
                  "Avoided redundant navigation to current location"
                )
              ) {
                console.log(e);
              }
            });
        } else {
          const { type } = this.$route.params;
          const { current_page } = this;
          this.$router
            .push({
              path: `/unattested-building-list/${type}`,
              query: {
                page: current_page,
                ...query
              },
            })
            .catch((e) => {
              if (
                e.name !== "NavigationDuplicated" &&
                !e.message.includes(
                  "Avoided redundant navigation to current location"
                )
              ) {
                console.log(e);
              }
            });
        }
      }

      if (
        (this.role == "admin" || this.role == "supervisor") &&
        this.$route.path ==
        `/unattested-building-list/${this.$route.params.type}`
      ) {
        const url = `/building/specificationlist/`;
        const params = {
          list: "selectionforadmin",
          search: this.search,
          region__shared_id: this.region,
          district: this.district,
          building_group: this.buildinggroup,
          limit: this.item_count,
          offset,
          status: this.$route.query.status || "",
          ...query
        };

        axios
          .get(url, { params })
          .then((response) => {
            this.unattestedCount = response.data.count
            this.buildsList = response.data.results;
            this.page_count = Math.ceil(response.data.count / this.item_count);
            this.current_page1 = this.$route.query.page
              ? parseInt(this.$route.query.page)
              : parseInt(this.$route.query.page);
          })
          .finally(() => {
            this.loading = false;
          });
      } else if (
        this.$route.path ==
        `/unattested-building-list/exg?page=${this.currentPage}&status=${status}`
      ) {
        const url = `/building/specificationlist/`;
        const params = {
          list: "selectionforadmin",
          buildingtype: type,
          search: this.search,
          region__shared_id: this.region,
          district: this.district,
          building_group: this.buildinggroup,
          limit: this.item_count,
          offset,
          status: this.$route.query.status || "",
          ...query
        };


        axios
          .get(url, { params })
          .then((response) => {
            this.unattestedCount = response.data.count
            this.buildsList = response.data.results;
            this.page_count = Math.ceil(response.data.count / this.item_count);
            this.current_page1 = this.$route.query.page
              ? parseInt(this.$route.query.page)
              : parseInt(this.$route.query.page);
          })
          .finally(() => {
            this.loading = false;
          });
      } else if (this.$route.path == "/unattested-building-list/new") {
        const {
          type,
          search,
          region,
          district,
          buildinggroup,
          item_count,
        } = this;
        axios
          .get("/building/specificationlist/", {
            params: {
              list: "selectionforadmin",
              buildingtype: type,
              search: search,
              region__shared_id: region,
              district: district,
              building_group: buildinggroup,
              limit: item_count,
              offset,
              status: this.$route.query.status || "",
              ...query
            },
          })
          .then((response) => {
            this.unattestedCount = response.data.count
            this.buildsList = response.data.results;
            this.page_count = Math.ceil(response.data.count / this.item_count);
            this.current_page1 = this.$route.query.page
              ? parseInt(this.$route.query.page)
              : parseInt(this.$route.query.page);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        const {
          type,
          search,
          region,
          district,
          buildinggroup,
          item_count,
        } = this;
        axios
          .get("/building/specificationlist/", {
            params: {
              list: "selection",
              buildingtype: type,
              search: search,
              region__shared_id: region,
              district: district,
              building_group: buildinggroup,
              limit: item_count,
              offset,
              status: this.$route.query.status || "",
              ...query
            },
          })
          .then((response) => {
            this.unattestedCount = response.data.count
            this.buildsList = response.data.results;
            this.page_count = Math.ceil(response.data.count / this.item_count);
            this.current_page1 = this.$route.query.page
              ? parseInt(this.$route.query.page)
              : parseInt(this.$route.query.page);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    routeTo(item, a) {
      const label = {
        'EXG': 'exist',
        'NEW': 'new',
        'exg': 'exist',
        'new': 'new',
      };

      const type = label[item.buildingtype] || 'exist';
      this.$router
        .push({
          path: `/${type}-build/${item.id}/${a}`,
          params: {
            id: this.$route.params.id,
          },
          query: {
            id: item.id,
            status: this.$route.query.status
          },
        })

    },
    regionChanged() {
      this.current_page = 1;
      this.current_page1 = 1;
      if (
        this.search != "" ||
        this.region != "" ||
        this.district != "" ||
        this.buildinggroup != "" ||
        this.item_count != 10
      ) {
        const { type } = this.$route.params;
        const {
          current_page,
          region,
          district,
          buildinggroup,
          item_count,
          search,
        } = this;
        this.$router
          .push({
            path: `/unattested-building-list/${type}`,
            query: {
              page: current_page,
              region,
              district,
              buildinggroup,
              item_count,
              search,
            },
          })
          .catch((e) => {
            if (
              e.name !== "NavigationDuplicated" &&
              !e.message.includes(
                "Avoided redundant navigation to current location"
              )
            ) {
              console.log(e);
            }
          });
      } else {
        const { type } = this.$route.params;
        const { current_page } = this;
        this.$router
          .push({
            path: `/unattested-building-list/${type}`,
            query: { page: current_page },
          })
          .catch((e) => {
            if (
              e.name !== "NavigationDuplicated" &&
              !e.message.includes(
                "Avoided redundant navigation to current location"
              )
            ) {
              console.log(e);
            }
          });
      }
      this.districts = [];
      this.district = "";
      this.getDistrict();
    },
    getNeighborhoods() {
      this.neighborhood = "";
      this.neighborhoods = [];
      axios.get(`/dictionary/neighborhood/?district=${this.district}`)
        .then((response) => {
          this.neighborhoods = response.data;
        });
    },
    getDistrict() {
      this.loading = true;
      axios
        .get(`/dictionary/district/?region__shared_id=${this.region}`)
        .then((response) => {
          this.districts = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    ChangeDistrict() {
      this.current_page = 1;
      this.current_page1 = 1;
      const {
        search,
        region,
        district,
        buildinggroup,
        item_count,
        current_page,
      } = this;
      const { type } = this.$route.params;
      if (search || region || district || buildinggroup || item_count !== 10) {
        this.$router.push({
          path: `/unattested-building-list/${type}`,
          query: {
            page: current_page,
            region,
            district,
            buildinggroup,
            item_count,
            search,
          },
        });
      } else {
        this.$router.push({
          path: `/unattested-building-list/${type}`,
          query: {
            page: current_page,
          },
        });
      }
    },
    DownloadExel(id, name) {
      axios({
        url: `/building/generate/${id}/building/`,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.setAttribute("download", `${name}-Bino-${id}.xlsx`);
        document.body.appendChild(fileLink);
        fileLink.click();
      });
    },
    downloadFile(file) {
      fetch(file)
        .then((resp) => resp.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          // the filename you want
          a.download = "PasportBino" || "file.json";
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        });
    },
    UserModal(a) {
      if (a != null && a.profile != null) {
        this.userData = a;
        this.usermodal = true;
      }
    },
    deleteBuilding(id) {
      return this.$confirm(`Сиз ростдан ҳам ушбу бинони ўчирмоқчимисиз?`, {
        confirmButtonText: "Ҳа",
        cancelButtonText: "Йўқ",
      }).then(() => {
        axios
          .delete(`/building/buildingdestroy/${id}/`)
          .then((response) => {
            this.$swal.fire({
              icon: "success",
              title: "Қониқарли. Бинони учирилди",
              timer: 3000,
            });
            this.__GET();
          })
          .catch((error) => {
            this.$swal.fire({
              icon: "error",
              title: "Бинони учиришда хатолик",
              timer: 3000,
            });
          });
      });
    },
    generate_building_list() {
      this.loading_generate = true;
      let type = this.$route.params.type.toUpperCase();
      let offset = this.item_count * (this.current_page - 1);
      const { search, region, district, buildinggroup, item_count } = this;
      const params = {
        buildingtype: type,
        search: search,
        region__shared_id: region,
        district: district,
        building_group: buildinggroup,
        limit: item_count,
        offset,
      };

      axios({
        url: "/building/generate_building_info/",
        method: "GET",
        params: params,
        responseType: "blob",
      })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", `Bino-1.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .finally(() => {
          this.loading_generate = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.top-header {
  margin-bottom: 20px;
}

.h-full {
  height: 100%;
}

.df {
  display: flex;
}

.jcsb {
  justify-content: space-between;
}

.jcc {
  justify-content: center;
}

.aic {
  align-items: center;
}

.unnatested-count {
  color: #3730A3;
  font-weight: 600;
  font-size: 20px;
}
</style>
